var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveIncidentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4994 0.285645C5.60658 0.285645 0.785156 5.10707 0.785156 10.9999C0.785156 16.8928 5.60658 21.7142 11.4994 21.7142C17.3923 21.7142 22.2137 16.8928 22.2137 10.9999C22.2137 5.10707 17.3923 0.285645 11.4994 0.285645ZM6.1423 12.7856C5.16016 12.7856 4.35658 11.9821 4.35658 10.9999C4.35658 10.0178 5.16016 9.21422 6.1423 9.21422C7.12444 9.21422 7.92801 10.0178 7.92801 10.9999C7.92801 11.9821 7.12444 12.7856 6.1423 12.7856ZM11.4994 12.7856C10.5173 12.7856 9.71373 11.9821 9.71373 10.9999C9.71373 10.0178 10.5173 9.21422 11.4994 9.21422C12.4816 9.21422 13.2852 10.0178 13.2852 10.9999C13.2852 11.9821 12.4816 12.7856 11.4994 12.7856ZM16.8566 12.7856C15.8744 12.7856 15.0709 11.9821 15.0709 10.9999C15.0709 10.0178 15.8744 9.21422 16.8566 9.21422C17.8387 9.21422 18.6423 10.0178 18.6423 10.9999C18.6423 11.9821 17.8387 12.7856 16.8566 12.7856Z",
    fill: "#0082E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIncidentsIcon);
export default __webpack_public_path__ + "static/media/activeIncidentsIcon.d1f8dabe329525cf2ed8341bc29e8289.svg";
export { ForwardRef as ReactComponent };